/** `sections/impact-report-founder.liquid` — `<impact-report-founder>`: toggles
 *  between a short message excerpt and the full statement, animating the
 *  container height between the two.
 */

class ImpactReportFounder extends HTMLElement {
  #abort
  #button
  #wrap
  #excerpt
  #full
  #expanded = false

  connectedCallback() {
    this.#button = this.querySelector('[data-toggle-message]')
    this.#wrap = this.querySelector('[data-message-wrap]')
    this.#excerpt = this.querySelector('[data-message-excerpt]')
    this.#full = this.querySelector('[data-message-full]')

    if (!this.#wrap) return

    this.#abort = new AbortController()
    const { signal } = this.#abort

    requestAnimationFrame(() => this.#setHeight())
    window.addEventListener('resize', this.#setHeight, { signal })

    if (!this.#button || !this.#excerpt || !this.#full) return

    this.#button.addEventListener('click', this.#onToggle, { signal })
  }

  disconnectedCallback() {
    this.#abort?.abort()
  }

  #onToggle = () => {
    this.#expanded = !this.#expanded
    this.classList.toggle('expanded', this.#expanded)

    if (this.#expanded) {
      this.#excerpt.classList.remove('active')
      this.#full.classList.add('active')
      this.#button.textContent = 'Show less'
    } else {
      this.#full.classList.remove('active')
      this.#excerpt.classList.add('active')
      this.#button.textContent = 'Read the full statement'
    }

    requestAnimationFrame(() => this.#setHeight())
  }

  #setHeight = () => {
    const active = this.querySelector('.impact-report-founder-message.active')
    if (!active || !this.#wrap) return
    this.#wrap.style.maxHeight = `${active.offsetHeight}px`
  }
}

if (!customElements.get('impact-report-founder')) {
  customElements.define('impact-report-founder', ImpactReportFounder)
}
